import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, useLocation, Redirect } from "react-router-dom";
import { trackPageView } from "../services/analyticsService";
import { SHOW_PLAN_INFO } from "../constants";

// Importing all the themes
import ThemeTwo from "../themes/theme-two";
import ThemeThree from '../themes/theme-three';
import ThemeFour from "../themes/theme-four";
import ThemeFive from "../themes/theme-five";
import ThemeSix from "../themes/theme-six";
import BlogTwoColumn from "../components/Blogs/BlogTwoColumn";
import BlogThreeColumn from "../components/Blogs/BlogThreeColumn";
import BlogLeftSidebar from "../components/Blogs/BlogLeftSidebar";
import BlogRightSidebar from "../components/Blogs/BlogRightSidebar";
import BlogDetailsLeftSidebar from "../components/Blogs/BlogDetailsLeftSidebar";
import BlogDetailsRightSidebar from "../components/Blogs/BlogDetailsRightSidebar";
import Reviews from "../components/ReviewSection/Reviews";
import Pricing from "../components/PricingSection/Pricing";
import Features from "../components/FeaturesSection/Features";
import DownloadPage from "../components/DownloadSection/DownloadPage";
import SubscribePage from "../components/SubscribeSection/SubscribePage";
import ThankYou from "../components/InnerSection/ThankYou";
import ComingSoon from "../components/InnerSection/ComingSoon";
import Login from "../components/Accounts/Login";
import Signup from "../components/Accounts/Signup";
import Forgot from "../components/Accounts/Forgot";
import Faq from "../components/FaqSection/Faq";
import ErrorPage from "../components/ErrorPage/404";
import ContactPage from "../components/ContactSection/ContactPage";

// Importing Legal Pages
import TermsOfService from "../components/LegalPages/TermsOfService";
import PrivacyPolicy from "../components/LegalPages/PrivacyPolicy";
import Disclaimer from "../components/LegalPages/Disclaimer";
import AboutUs from '../components/LegalPages/AboutUs';
import Careers from '../components/LegalPages/Careers';
import UserDataDeletion from '../components/LegalPages/UserDataDeletion';
import PrivacyRequestPage from '../components/LegalPages/PrivacyRequestPage';
import PrivacyVerifyPage from '../components/LegalPages/PrivacyVerifyPage';

// Importing Test Components
import PricingTest from "../components/PricingSection/PricingTest";
import PricingDebug from "../components/PricingSection/PricingDebug";
import PaymentTest from "../components/PaymentSection/PaymentTest";
import CountryCurrencyTest from "../components/HeroSection/CountryCurrencyTest";

// Custom hook to track page views
const usePageTracking = () => {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};

const MyRouts = () => {
  return (
    <div>
      <Router>
        <PageTracker />
        <Switch>
          <Route exact path="/" component={ThemeFive} />
          <Route path="/theme-two" component={ThemeTwo} />
          <Route path="/theme-three" component={ThemeThree} />
          <Route path="/theme-four" component={ThemeFour} />
          <Route path="/theme-five" component={ThemeFive} />
          <Route path="/theme-six" component={ThemeSix} />
          <Route path="/blog-two-column" component={BlogTwoColumn} />
          <Route path="/blog-three-column" component={BlogThreeColumn} />
          <Route path="/blog-left-sidebar" component={BlogLeftSidebar} />
          <Route path="/blog-right-sidebar" component={BlogRightSidebar} />
          <Route path="/blog-details-left-sidebar" component={BlogDetailsLeftSidebar} />
          <Route path="/blog-details-right-sidebar" component={BlogDetailsRightSidebar} />
          <Route path="/reviews" component={Reviews} />
          <Route path="/pricing" render={() => (SHOW_PLAN_INFO ? <Pricing /> : <Redirect to="/" />)} />
          <Route path="/features" component={Features} />
          <Route path="/download-page" component={DownloadPage} />
          <Route path="/subscribe-page" component={SubscribePage} />
          <Route path="/thank-you" component={ThankYou} />
          <Route path="/coming-soon" component={ComingSoon} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/forgot" component={Forgot} />
          <Route path="/faq" component={Faq} />
          <Route path="/error-page" component={ErrorPage} />
          <Route path="/contact-page" component={ContactPage} />
          
          {/* Legal Pages Routes */}
          <Route path="/terms" component={TermsOfService} />
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/disclaimer" component={Disclaimer} />
          <Route path="/about" component={AboutUs} />
          <Route path="/careers" component={Careers} />
          <Route path="/data-deletion/verify" component={PrivacyVerifyPage} />
          <Route exact path="/data-deletion" component={PrivacyRequestPage} />
          <Route path="/data-deletion-policy" component={UserDataDeletion} />
          
          {/* Test Routes */}
          <Route path="/pricing-test" component={PricingTest} />
          <Route path="/pricing-debug" component={PricingDebug} />
          <Route path="/payment-test" component={PaymentTest} />
          <Route path="/country-currency-test" component={CountryCurrencyTest} />
        </Switch>
      </Router>
    </div>
  );
}

// Component to track page views
const PageTracker = () => {
  usePageTracking();
  return null;
};

export default MyRouts;